<div class="main-header">
  <button class="btn-mobile-menu" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling"
    aria-controls="offcanvasScrolling">
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="white">
      <rect y="6" width="24" height="2" rx="2" />
      <rect y="14" width="24" height="2" rx="2" />
      <rect y="22" width="24" height="2" rx="2" />
    </svg>
  </button>
  <div class="logo-leapmotor">
    <img src="assets/images/logo-leapmotor-white.svg" alt="Logo" class="img-fluid">
  </div>

  <a *ngIf="this.countNotification > 0" class="btn-notifications" id="notifBell"
    (click)="getCountNotification(true)" [hidden]="false" type="button" data-bs-toggle="offcanvas"
    href="#offcanvasNotification" role="button" aria-controls="offcanvasNotification" title="Notificaciones">
    <div class="position-relative">
      <img src="../../../../assets/images/icons/icon-bell-white.svg" alt="Notificaciones">
      <span class="badge-pill" *ngIf="this.countNotification> 0">
        {{this.countNotification}}
        <span class="visually-hidden">No leídos</span>
      </span>
    </div>
  </a>

  <!--Off canvas - Notifications -->
  <div class="offcanvas offcanvas-end sidebar_notifications" tabindex="-1" id="offcanvasNotification"
    aria-labelledby="offcanvasNotificationLabel">
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasNotificationLabel"><img src="../../../../assets/images/icons/icon-bell-white.svg" alt="Notificaciones"> Alertas</h5>
      <button id="closeModalButton" type="button" class="btn-close btn-close-white text-reset" data-bs-dismiss="offcanvas"
        aria-label="Close"></button>
    </div>

    <div class="offcanvas-body" *ngIf="showNotifications && this.countNotification > 0 && this.data.length > 0">
      <ng-container *ngFor="let item of this.data">
        <div class="cont__alert">
          <div class="date">
            {{item.PublishSince}}
          </div>
          <ng-container *ngIf="item.Url != null">
            <a *ngIf="item.Url != null && item.Url.length > 0 && item.ExternalUrl == true" href="{{item.Url}}"
              target="{{item.UrlOpenNew == true? '_blank':''}}" (click)="closeNotification(item.IdNotification)">
              <h6>{{item.Title}}</h6>
              <div class="cont__text_alert">
                <div [innerHTML]="item.Content" class="text_alert"></div>
                <div class="icon_link"></div>
              </div>
            </a>
            <a *ngIf="item.Url != null && item.Url.length > 0 && item.ExternalUrl == false" class="pointer"s
              [routerLink]="[item.Url]" target="{{item.UrlOpenNew==true? '_blank' :''}}"
              (click)="closeNotification(item.IdNotification)">
              <h6>{{item.Title}}</h6>
              <div class="cont__text_alert">
                <div [innerHTML]="item.Content" class="text_alert"></div>
                <div class="icon_link"></div>
              </div>
            </a>
          </ng-container>
          <ng-container *ngIf="item.Url == null">
            <h6>{{item.Title}}</h6>
            <div [innerHTML]="item.Content" class="text_alert"></div>
          </ng-container>
        </div>
      </ng-container>
      <button class="btn-white-line w-100" (click)="loadMore()" *ngIf="showMore">Cargar más</button>
    </div>
  </div>
</div>